import { useQuery } from '@tanstack/react-query'

import {
  getInboxMaxSeverity,
  getInboxTotal,
  getPharmacyInbox,
  type InboxCategory,
  type InboxSeverity,
} from '../services/inbox'

export interface UseInboxResult {
  categories: InboxCategory[]
  total: number
  maxSeverity: InboxSeverity | null
  isLoading: boolean
}

export const useInbox = (pharmacyId: string | null): UseInboxResult => {
  const q = useQuery({
    queryKey: ['inbox', pharmacyId],
    queryFn: () => getPharmacyInbox(pharmacyId ?? ''),
    enabled: Boolean(pharmacyId),
    staleTime: 30_000,
    refetchInterval: 60_000,
  })

  const categories = q.data ?? []
  return {
    categories,
    total: getInboxTotal(categories),
    maxSeverity: getInboxMaxSeverity(categories),
    isLoading: q.isLoading,
  }
}
